import { type NamePath, type TabDef, type TabFieldError } from "./tab-types.ts"

function toPath(name: NamePath): Array<string | number> {
  return Array.isArray(name) ? name : [name]
}

export function fieldBelongsToTab(
  errorName: Array<string | number>,
  tabFields: NamePath[]
): boolean {
  return tabFields.some((field) => {
    const fieldPath = toPath(field)
    if (fieldPath.length > errorName.length) return false
    return fieldPath.every((seg, i) => seg === errorName[i])
  })
}

export function getTabErrorCounts(
  tabs: TabDef[],
  errorFields: TabFieldError[]
): Map<string, number> {
  const withErrors = errorFields.filter((f) => (f.errors?.length ?? 0) > 0)
  const counts = new Map<string, number>()
  for (const tab of tabs) {
    const n = withErrors.filter((f) => fieldBelongsToTab(f.name, tab.fields)).length
    if (n > 0) counts.set(tab.key, n)
  }
  return counts
}

export function findFirstErrorTabKey(
  tabs: TabDef[],
  errorFields: TabFieldError[]
): string | undefined {
  for (const tab of tabs) {
    if (errorFields.some((f) => fieldBelongsToTab(f.name, tab.fields))) return tab.key
  }
  return undefined
}
